// extracted by mini-css-extract-plugin
export default {"root":"QuantitySelect_root__jqoit"};